module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3097f45d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/burst/map.vue
// module id = 1201
// module chunks = 2